import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      {/* Header */}
      <header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Airlive Logo" />
          </Link>
        </div>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/#about">About</Link>
          <Link to="/#branches">Branches</Link>
          <Link to="/#services">Services</Link>
          <Link to="/#gallery">Gallery</Link>
        </nav>
      </header>

      {/* Privacy Policy Content */}
      <div className="privacy-content-page">
        <div className="container">
          <button className="close-btn" onClick={() => window.history.back()}>
            ✖
          </button>
          <h1>Privacy Policy for Airlive Loyalty App</h1>
          <p><strong>Last Updated: October 12, 2025</strong></p>
          <p>
            Airlive Loyalty ("we," "our," or "us") operates the Airlive Loyalty mobile application ("App"). 
            This Privacy Policy describes how we collect, use, and protect your personal information when 
            you use our App and related services.
          </p>
          <p>
            By using our App, you agree to the collection and use of information in accordance with this Privacy Policy.
          </p>
          <p>⸻</p>
          
          <h2>1. Information We Collect</h2>
          <p>We collect the following types of information to provide you with a personalized loyalty experience:</p>
          
          <h3>Personal Information</h3>
          <p>When you register or use our App, we may collect:</p>
          <ul>
            <li>Full Name</li>
            <li>Mobile Number</li>
            <li>Email Address</li>
            <li>Date of Birth</li>
            <li>Anniversary Date</li>
          </ul>
          <p>Providing this information helps us manage your loyalty profile, deliver rewards, and communicate offers.</p>
          
          <h3>Usage Information</h3>
          <p>We automatically collect certain data when you use our App, such as:</p>
          <ul>
            <li>Device type, model, and operating system</li>
            <li>IP address</li>
            <li>App pages viewed, session duration, and actions taken</li>
            <li>Date and time of usage</li>
          </ul>
          <p>This information helps us improve app performance and user experience.</p>
          <p>⸻</p>
          
          <h2>2. How We Use Your Information</h2>
          <p>We use the collected data to:</p>
          <ul>
            <li>Provide and maintain the loyalty program</li>
            <li>Send personalized rewards, discounts, and offers</li>
            <li>Communicate updates and service-related notifications</li>
            <li>Improve app functionality and user experience</li>
            <li>Analyze usage for performance and feature improvements</li>
            <li>Respond to user support or feedback requests</li>
          </ul>
          <p>We may also share limited data with our trusted partners or associated outlets to enhance your customer experience.</p>
          <p>⸻</p>
          
          <h2>3. Data Sharing and Disclosure</h2>
          <p>We do not sell or rent your personal data to any third party.</p>
          <p>Your data may be shared with:</p>
          <ul>
            <li>Service Providers assisting in app operations, hosting, or analytics</li>
            <li>Airlive partner venues or loyalty outlets to facilitate offers or rewards</li>
            <li>Legal authorities, if required to comply with applicable laws</li>
          </ul>
          <p>All third parties are required to maintain the confidentiality and security of your data.</p>
          <p>⸻</p>
          
          <h2>4. Data Security</h2>
          <p>
            We use reasonable and industry-accepted security measures to protect your personal information 
            from unauthorized access, alteration, or disclosure. However, please note that no digital platform 
            or electronic storage system is 100% secure. We take all possible precautions but cannot guarantee 
            absolute security.
          </p>
          <p>⸻</p>
          
          <h2>5. Data Retention</h2>
          <p>
            We keep your personal data only for as long as necessary to provide the loyalty services and 
            comply with legal obligations. You may request deletion of your account and data at any time 
            by contacting us.
          </p>
          <p>⸻</p>
          
          <h2>6. Your Privacy Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction or deletion</li>
            <li>Withdraw consent for promotional communications</li>
          </ul>
          <p>To exercise these rights, please contact us at gachibowli@theairlive.com.</p>
          <p>⸻</p>
          
          <h2>7. Children's Privacy</h2>
          <p>
            Our App is intended for users aged 13 and above. We do not knowingly collect personal data 
            from children under 13. If you believe your child has provided us with personal data, please 
            contact us to have it removed.
          </p>
          <p>⸻</p>
          
          <h2>8. Updates to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Updates will be posted on this page with an 
            updated "Last Updated" date. For major changes, we will notify you through the App or via email.
          </p>
          <p>⸻</p>
          
          <h2>9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or how we handle your data, please contact us:</p>
          <ul>
            <li>Email: airlive.app@gmail.com</li>
            <li>Phone: +91 91606 10002</li>
            <li>Website: https://airlivegachibowli.com/privacy</li>
          </ul>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Alive Hospitality. All Rights Reserved to alive hospitality.</p>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
